import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { MatExpansionPanel } from "@angular/material/expansion";
import { SubtaskModel, SubtaskComment } from "../../service/task-mgmt.service";

@Component({
    selector: "app-subtask-item",
    templateUrl: "./subtask-item.component.html",
    styleUrls: ["./subtask-item.component.scss"],
    standalone: false
})
export class SubtaskItemComponent implements AfterViewInit, OnChanges {
  @ViewChild(MatExpansionPanel) panel!: MatExpansionPanel;

  @Input() subtask!: SubtaskModel;
  @Input() index = 0;
  @Input() initiallyExpanded = false;
  @Input() isViewMode = false;
  @Input() isEditMode = false;
  @Input() isCreateMode = false;
  @Input() currentUserName = "";

  @Output() subtaskChange = new EventEmitter<SubtaskModel>();
  @Output() removeSubtask = new EventEmitter<number>();
  @Output() commentAdded = new EventEmitter<{ index: number; comment: SubtaskComment }>();
  @Output() editRequested = new EventEmitter<void>();

  newCommentText = "";

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isEditMode'] && changes['isEditMode'].currentValue === true && this.panel) {
      setTimeout(() => this.panel.open(), 0);
    }
  }

  ngAfterViewInit(): void {
    if (this.initiallyExpanded && this.panel) {
      setTimeout(() => this.panel.open(), 0);
    }
  }

  get canEditSubtask(): boolean {
    return this.isCreateMode || this.isEditMode;
  }

  get canAddComment(): boolean {
    return this.isEditMode || this.isViewMode;
  }

  get statusLabel(): string {
    const labels: Record<string, string> = {
      planned: "Planned",
      "in-progress": "In Progress",
      done: "Done",
      cancelled: "Cancelled",
    };
    return labels[this.subtask.status] || this.subtask.status;
  }

  get priorityLabel(): string {
    const labels: Record<string, string> = {
      low: "Low",
      medium: "Medium",
      high: "High",
    };
    return labels[this.subtask.priorityLevel] || this.subtask.priorityLevel;
  }

  get assigneeLabel(): string {
    if (!this.subtask.assignTo) return "Unassigned";
    return this.subtask.assignTo;
  }

  onSubtaskChange(updated: SubtaskModel): void {
    this.subtaskChange.emit(updated);
  }

  onRemoveSubtask(index: number): void {
    this.removeSubtask.emit(index);
  }

  onEditRequested(): void {
    this.editRequested.emit();
  }

  onAddComment(): void {
    if (!this.newCommentText.trim()) return;

    const comment: SubtaskComment = {
      text: this.newCommentText.trim(),
      author: this.currentUserName || "Unknown",
      date: new Date().toISOString(),
    };

    this.commentAdded.emit({ index: this.index, comment });
    this.newCommentText = "";
  }
}
